import { render } from "./CustomHeader.vue?vue&type=template&id=0a0d9a2c&scoped=true&ts=true"
import script from "./CustomHeader.vue?vue&type=script&lang=ts"
export * from "./CustomHeader.vue?vue&type=script&lang=ts"

import "./CustomHeader.vue?vue&type=style&index=0&id=0a0d9a2c&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0d9a2c"]])

export default __exports__